export var Level;
(function (Level) {
    Level["none"] = "none";
    Level["error"] = "error";
    Level["warn"] = "warn";
    Level["info"] = "info";
    Level["log"] = "log";
    Level["debug"] = "debug";
})(Level || (Level = {}));
/**
 * Log level priority. A lower number means lower priority.
 * This is used in the followeding fashion. If the global or local priority is set at X, then only
 * messages with a priority greater than or equal to X are output. Others are ignored.
 *
 * So, when the global priority is set at error (default for production env), only error messages
 * are emitted and everything else is ignored.
 *
 * Locally, the global priority is set at debug. Therefore, debug, log, info, warn, and error
 * messages are all emitted.
 *
 * You can change the global priority (or local priority of individual logger instances) to any
 * level to suit your particular use case by invoking `setLoggingLevel()`.
 */
export var LevelPriority;
(function (LevelPriority) {
    LevelPriority[LevelPriority["none"] = 10] = "none";
    LevelPriority[LevelPriority["error"] = 4] = "error";
    LevelPriority[LevelPriority["warn"] = 3] = "warn";
    LevelPriority[LevelPriority["info"] = 2] = "info";
    LevelPriority[LevelPriority["log"] = 2] = "log";
    LevelPriority[LevelPriority["debug"] = 1] = "debug";
})(LevelPriority || (LevelPriority = {}));
